// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLoader_root__3iLJf"};